import usePendingState from '../../Hooks/usePendingState';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';

const types = [
    { value: 'facebook', label: 'Facebook' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'x', label: 'X (Twitter)' },
    { value: 'pinterest', label: 'Pinterest' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'youtube', label: 'YouTube' },
    { value: 'tiktok', label: 'TikTok' },
];

const FormAddSocialLink = () => {
    const { setNotification } = useNotification();
    const [loading, setLoading] = useState(true);
    const [socialLinkData, setSocialLinkData] = useState({
        tipo: '',
        link: '',
    });

    const [socialLinkErrorData, setSocialLinkErrorData] = useState({
        tipo: [],
        link: [],
    });

    const [formLoading, setFormLoading, formPendingRef] = usePendingState();

    const navigate = useNavigate();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSocialLinkData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSelectChange = (name, selectedOption) => {
        setSocialLinkData((prevData) => ({
            ...prevData,
            [name]: selectedOption.value,
        }));
    };

    useEffect(() => {
        setLoading(false);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formPendingRef.current) return;
        setFormLoading(true);

        try {
            const response = await fetch(`${baseUrl}/manager/redes-sociais/novo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(socialLinkData),
            });
            if (response.ok) {
                setNotification({
                    type: 'success',
                    message: 'Rede social adicionada com sucesso!',
                    show: true,
                });
                navigate('/manager/');
            } else {
                if (response.status === 422) {
                    const errors = await response.json();
                    setSocialLinkErrorData(errors);
                } else {
                    throw new Error('Erro ao adicionar nova rede social.');
                }
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setFormLoading(false);
        }
    };

    if (loading)
        return (
            <div className="mx-auto py-20 flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent" />
            </div>
        );

    return (
        <>
            <Link
                to="/manager"
                className="bg-slate-100 px-4 py-1.5 rounded border border-slate-300 float-right ml-2 transition-all hover:bg-slate-200"
            >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                Voltar
            </Link>

            <h4 className="mb-6 text-xl font-bold text-black">Adicionar rede social</h4>

            <div className="flex flex-col">
                <form onSubmit={handleSubmit} className="max-w-5xl pb-10">
                    <div className="mb-6 2xl:mb-10">
                        <div className="mb-3 flex gap-5 flex-col lg:flex-row w-full lg:w-3/4">
                            <div className="w-full md:w-1/2">
                                <label className="block text-sm font-medium mb-1">Rede social</label>
                                <Select
                                    name="tipo"
                                    options={types}
                                    onClick={() => setSocialLinkErrorData((prevData) => ({ ...prevData, tipo: [] }))}
                                    onChange={(selectedOption) => handleSelectChange('tipo', selectedOption)}
                                    placeholder="Selecione uma opção..."
                                    classNamePrefix="admin-select"
                                    className="group-select"
                                />
                                {socialLinkErrorData.tipo && socialLinkErrorData.tipo[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {socialLinkErrorData.tipo[0]}{' '}
                                        <span
                                            onClick={() => setSocialLinkErrorData((prevData) => ({ ...prevData, tipo: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                            
                            <div className="w-full md:w-1/2">
                                <label className="block text-sm font-medium mb-1">Link</label>
                                <input
                                    type="text"
                                    name="link"
                                    value={socialLinkData.link}
                                    onClick={() => setSocialLinkErrorData((prevData) => ({ ...prevData, link: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {socialLinkErrorData.link && socialLinkErrorData.link[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {socialLinkErrorData.link[0]}{' '}
                                        <span
                                            onClick={() => setSocialLinkErrorData((prevData) => ({ ...prevData, link: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={formLoading}
                        aria-busy={formLoading}
                        className="w-full lg:w-3/4 bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    >
                        {!formLoading ? 'Salvar' : <Loading />}
                    </button>
                </form>
            </div>
        </>
    );
};

export default FormAddSocialLink;
